import { Injectable } from '@angular/core';

import { RidangoEpic } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { StopsService } from '../stops.service';
import { StopsActions } from './stops.actions';

@Injectable({
    providedIn: 'root',
})
export class StopsEpics implements RidangoEpic {
    constructor(private actions: StopsActions, private service: StopsService) {}

    register() {
        return [this.fetchStops, this.fetchIntercityStops, this.fetchZones, this.fetchStopsWithZones];
    }

    fetchStops = (action$: ActionsObservable<any>) =>
        action$.ofType(StopsActions.FETCH_START).pipe(
            switchMap((action) => {
                return this.service.getAllStopsRequest().pipe(
                    map((response) => this.handleStopsRequestSuccess(response)),
                    catchError((error) => of(this.actions.fetchFailed(error)))
                );
            })
        );

    private handleStopsRequestSuccess(response) {
        const byId = {};
        response.map((stops) => {
            byId[stops.stop_id] = stops;
        });

        return this.actions.fetchSuccess({ all: response, byId: byId });
    }

    fetchIntercityStops = (action$: ActionsObservable<any>) =>
        action$.ofType(StopsActions.FETCH_INTERCITY_START).pipe(
            switchMap((action) => {
                return this.service.getStopsRequest().pipe(
                    map((response) => this.handleIntercityStopsRequestSuccess(response)),
                    catchError((error) => of(this.actions.fetchIntercityStopsFailed(error)))
                );
            })
        );

    private handleIntercityStopsRequestSuccess(response) {
        const byId = {};
        response.map((stops) => {
            byId[stops.id] = stops;
        });

        return this.actions.fetchIntercityStopsSuccess({ all: response, byId: byId });
    }

    fetchZones = (action$: ActionsObservable<any>) =>
        action$.ofType(StopsActions.FETCH_ZONES_START).pipe(
            switchMap((action) => {
                return this.service.getAllZonesRequest().pipe(
                    map((response) => this.handleZonesRequestSuccess(response)),
                    catchError((error) => of(this.actions.fetchZonesFailed(error)))
                );
            })
        );

    private handleZonesRequestSuccess(response) {
        const byId = {};
        response.map((stop) => {
            byId[stop.id] = stop;
            stop.display = stop.name;
            return stop;
        });

        return this.actions.fetchZonesSuccess({ all: response, byId: byId });
    }

    fetchStopsWithZones = (action$: ActionsObservable<any>) =>
        action$.ofType(StopsActions.FETCH_STOPS_WITH_ZONES_START).pipe(
            switchMap((action) => {
                return this.service.getStopsWithZonesRequest().pipe(
                    map((response) => this.handleStopsWithZonesRequestSuccess(response)),
                    catchError((error) => of(this.actions.fetchStopsWithZonesFailed(error)))
                );
            })
        );

    private handleStopsWithZonesRequestSuccess(response) {
        response.map((stop) => {
            stop.name = stop.stop_name;
            stop.display = stop.stop_name;
            return stop;
        });

        return this.actions.fetchZonesSuccess({ all: response });
    }
}
